module.exports = __webpack_public_path__ + "media/question1.849ea4d7.mp3";